'use client';

import { FormEvent, useState } from 'react';
import { Box, Modal, Divider } from '@wishket/design-system';

import PrivacyUse from '../PrivacyUse';
import PrivacySubscribe from '../PrivacySubscribe';

import {
  Container,
  GradientScrollContainer,
  CheckboxListItemWithInfo,
} from './AlarmSettingModal.parts';

interface AlarmSettingModalProps {
  isOpen: boolean;
  isDesktop: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const AlarmSettingModal = ({
  isOpen,
  isDesktop,
  onClose,
  onSubmit,
}: AlarmSettingModalProps) => {
  const [isUsage, setIsUsage] = useState(false);
  const [isReception, setIsReception] = useState(false);
  const [isUsageOpen, setIsUsageOpen] = useState(false);
  const [isReceptionOpen, setIsReceptionOpen] = useState(false);

  const isAgreeAll = isUsage && isReception;

  const onAgreeAll = () => {
    setIsUsage(!isAgreeAll);
    setIsReception(!isAgreeAll);
  };

  const onReset = () => {
    setIsUsage(false);
    setIsReception(false);
  };

  const onUsage = () => {
    setIsUsage(!isUsage);
    setIsReception(!isUsage);
  };

  const onReception = () => {
    setIsReception(!isReception);
    if (!isUsage) {
      setIsUsage(!isReception);
    }
  };

  const onReceptionOpen = () => {
    setIsUsageOpen(false);
    setIsReceptionOpen(!isReceptionOpen);
  };

  const onUsageOpen = () => {
    setIsReceptionOpen(false);
    setIsUsageOpen(!isUsageOpen);
  };

  const onCloseWithReset = () => {
    onReset();
    onClose();
  };

  const onSubmitWithTimer = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsUsageOpen(false);
    setIsReceptionOpen(false);

    if (isAgreeAll) return onSubmit();

    onAgreeAll();
    const timer = setTimeout(() => {
      onSubmit();
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  };

  return (
    <Modal
      size="md"
      rootId="portal"
      isOpen={isOpen}
      variant={isDesktop ? 'default' : 'full'}
      onClose={onCloseWithReset}
    >
      <Container
        onClose={onCloseWithReset}
        onSubmit={onSubmitWithTimer}
        isDesktop={isDesktop}
      >
        <Box className="flex flex-col gap-4">
          <Box className="flex flex-col gap-4 rounded-xl bg-w-gray-10 px-6 py-5">
            <CheckboxListItemWithInfo
              label="개인정보 마케팅 활용 동의"
              testId="marketing-usage-checkbox"
              checked={isUsage}
              onChecked={onUsage}
              open={isUsageOpen}
              onOpen={onUsageOpen}
            />
            {isUsageOpen && (
              <GradientScrollContainer>
                <PrivacyUse />
              </GradientScrollContainer>
            )}
            <Divider isSub />
            <CheckboxListItemWithInfo
              label="마케팅 정보 수신 동의"
              testId="marketing-reception-checkbox"
              checked={isReception}
              onChecked={onReception}
              open={isReceptionOpen}
              onOpen={onReceptionOpen}
            />
            {isReceptionOpen && (
              <GradientScrollContainer>
                <PrivacySubscribe />
              </GradientScrollContainer>
            )}
          </Box>
        </Box>
      </Container>
    </Modal>
  );
};

export default AlarmSettingModal;
